import { AlertTriangle, CheckCircle2 } from "lucide-react";

const RULES = [
  "All compounds are sold strictly as analytical reference standards for in-vitro laboratory research.",
  "Products are not drugs, supplements, or cosmetics, and are not for human or veterinary administration under any circumstances.",
  "Every order request requires a signed Research Use Only attestation and hold-harmless waiver before it is reviewed.",
  "Signed waivers are retained on file and a copy is emailed to the signer for their compliance records.",
  "We reserve the right to decline any order request that suggests non-research intent.",
];

export default function Compliance() {
  return (
    <section id="compliance" className="bg-[#0B111A] text-white" data-testid="compliance-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <div className="flex items-center gap-3 mb-4">
          <AlertTriangle className="h-6 w-6 text-amber-400" />
          <p className="font-tech text-xs uppercase tracking-[0.18em] text-amber-400">Compliance &amp; RUO Protocol</p>
        </div>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight max-w-2xl">
          Research Use Only — Without Exception
        </h2>
        <div className="mt-10 grid md:grid-cols-2 gap-x-12 gap-y-5 max-w-4xl">
          {RULES.map((r) => (
            <div key={r} className="flex gap-3">
              <CheckCircle2 className="h-5 w-5 text-emerald-400 shrink-0 mt-0.5" />
              <p className="text-sm text-slate-300 leading-relaxed">{r}</p>
            </div>
          ))}
        </div>
        <p className="mt-10 font-tech text-[11px] uppercase tracking-[0.16em] text-slate-500 border-t border-slate-800 pt-6">
          These statements have not been evaluated by the FDA. Products listed are not intended to diagnose, treat, cure, or prevent any disease.
        </p>
      </div>
    </section>
  );
}
